export default __webpack_public_path__ + "static/media/jazz_logo_mobile.a2a0bc69.svg";